import { IPalletEdited } from '../types/palletItem';

export const filterPallets = (
    list: IPalletEdited[],
    input: string,
    activeTab: string,
    selectedTab: string,
): IPalletEdited[] => {
    const trimmed = input.trim();
    return list.filter(
        (item) =>
            (activeTab === selectedTab ? item.isSelected : !item.isSelected) &&
            (item.Pallet_Num?.toString().includes(trimmed) ||
                (!!item.ExtermalNum && item.ExtermalNum.toString().includes(trimmed)) ||
                item.Details.some((e) =>
                    `${e.ProductDesc?.trim()} ${e.VarietyDesc?.trim()}`
                        .toLocaleLowerCase()
                        .includes(input),
                )),
    );
};
